import { Icon } from '@billy/design-system'
import { Menu } from '@shinetools/lumen-react'
import { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReviewEntriesFilterType } from '../../../enums/reviewEntriesFilterType'
import { AddFilterTrigger, FilterTypeMenuItem, PopoverBody, PopoverCard } from '../styles'

interface ReviewEntriesAddFilterMenuProps {
  availableTypes: ReviewEntriesFilterType[]
  getTypeLabel: (type: ReviewEntriesFilterType) => string
  onSelect: (type: ReviewEntriesFilterType) => void
}

export const ReviewEntriesAddFilterMenu = ({
  availableTypes,
  getTypeLabel,
  onSelect,
}: ReviewEntriesAddFilterMenuProps): ReactElement | null => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  if (availableTypes.length === 0) {
    return null
  }

  const handleSelect = (type: ReviewEntriesFilterType) => {
    onSelect(type)
    setIsOpen(false)
  }

  return (
    <Menu
      onOpenChange={setIsOpen}
      open={isOpen}
      placement="bottom-start"
      size="small"
      trigger={
        <AddFilterTrigger type="button">
          <Icon color="currentColor" icon="plus" size="sm" />
          {t('review_entries.filters.action.add')}
        </AddFilterTrigger>
      }
    >
      <PopoverCard>
        <PopoverBody>
          {availableTypes.map((type) => (
            <FilterTypeMenuItem key={type} onClick={() => handleSelect(type)} type="button">
              {getTypeLabel(type)}
            </FilterTypeMenuItem>
          ))}
        </PopoverBody>
      </PopoverCard>
    </Menu>
  )
}
